import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { navLinks, socials } from "../config";
import Potrait from "../assets/potrait.svg";
import { Helmet } from "react-helmet";
import Close from "../assets/icons/close.svg";
import Bar from "../assets/icons/bar.svg";
import { renderLogoIcon } from "../utils/utils";

const StyledMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const StyledHamburgerButton = styled.div`
  position: relative;
  z-index: var(--z-hamburger);
  cursor: pointer;

  .menu-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }
`;

const StyledSidebar = styled.aside`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    height: 100vh;
    width: 100%;
    outline: 0;
    background-color: var(--black-dark);
    z-index: var(--z-aside);
    transform: translateX(${(props) => (props.menuOpen ? 0 : 100)}vw);
    visibility: ${(props) => (props.menuOpen ? "visible" : "hidden")};
    transition: var(--transition);
    padding-top: var(--mb-6);
  }
`;

const StyledNavMenu = styled.nav`
  position: relative;
`;

const StyledPotrait = styled.div`
  height: 45%;

  @media (min-height: 667px) {
    height: 50%;
  }

  margin-bottom: var(--mb-2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  position: relative;

  h2 {
    color: var(--gray-light);
    font-size: var(--big-font-size);
    font-weight: var(--font-normal);
    margin-top: var(--mb-1);
  }
  p {
    color: var(--gray-dark);
    font-size: var(--small-font-size);
    font-weight: var(--font-light);
  }
`;

const StyleNavMenuList = styled.ul`
  position: relative;
`;

const StyleNavMenuListItem = styled.li`
  color: var(--white);
  padding-bottom: var(--mb-1);

  @media (min-height: 667px) {
    padding-bottom: var(--mb-2);
  }
  &:hover a {
    color: var(--primary);
  }
`;

const StyledNavLink = styled.a`
  font-size: var(--normal-font-size);
  cursor: pointer;
  font-weight: var(--font-normal);
  color: var(--white);

  @media (min-width: 768px) {
    font-size: var(--normal-large-font-size);
  }
`;

const StyledResumeButtonContainer = styled.div`
  padding: var(--mb-3) 0;

  @media (max-height: 667px) {
    padding: var(--mb-2) 0;
  }
`;

const StyledResumeButton = styled.a`
  display: block;
  border-radius: var(--border-radius);
  font-size: var(--normal-font-size);
  font-weight: var(--font-semi);
  background: var(--white);
  padding: 4px 2px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: var(--normal-large-font-size);
  }
`;

const StyledSocialList = styled.ul`
  position: relative;
`;

const StyledSocialListItem = styled.li`
  margin-right: var(--mb-2);
  float: left;
  position: relative;

  &:hover a {
    fill: var(--gray-light);
  }
`;

const StyledSocialLink = styled.a`
  font-size: var(--big-font-size);
  cursor: pointer;
  fill: var(--gray-dark);

  .social-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }

  @media (min-width: 768px) {
    .social-icon {
      width: 30px;
      height: 30px;
    }
  }
`;

const Menu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const _onResize = (e) => {
    if (e.currentTarget.innerWidth > 768) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", _onResize);
      return () => {
        window.removeEventListener("resize", _onResize);
      };
    }
  }, []);

  const _handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <StyledMenu>
      <Helmet>
        <body className={menuOpen ? "overflow-hide" : ""} />
      </Helmet>
      <StyledHamburgerButton
        onClick={_handleToggleMenu}
        style={{
          fill: menuOpen ? "var(--gray-extra-light)" : "var(--black-dark)",
        }}
      >
        {menuOpen ? <Close className="menu-icon" /> : <Bar menu-icon />}
      </StyledHamburgerButton>
      <StyledSidebar
        menuOpen={menuOpen}
        aria-hidden={!menuOpen}
        tabIndex={menuOpen ? 1 : -1}
      >
        <StyledPotrait>
          <Potrait />
          <h2>Low Zi Jian</h2>
          <p>@jakelow</p>
        </StyledPotrait>
        <StyledNavMenu>
          {navLinks ? (
            <StyleNavMenuList>
              {navLinks.map((item, i) => (
                <StyleNavMenuListItem key={`nav-${i}`}>
                  <StyledNavLink href={item.url} onClick={_handleToggleMenu}>
                    {item.name}
                  </StyledNavLink>
                </StyleNavMenuListItem>
              ))}
            </StyleNavMenuList>
          ) : null}
          <StyledResumeButtonContainer>
            <StyledResumeButton
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </StyledResumeButton>
          </StyledResumeButtonContainer>
          <StyledSocialList>
            {socials.map((item, i) => (
              <StyledSocialListItem key={`social-${i}`}>
                <StyledSocialLink
                  href={item.url}
                  onClick={_handleToggleMenu}
                  target="_blank"
                >
                  {renderLogoIcon(item.name, "social-icon")}
                </StyledSocialLink>
              </StyledSocialListItem>
            ))}
          </StyledSocialList>
        </StyledNavMenu>
      </StyledSidebar>
    </StyledMenu>
  );
};

export default Menu;
